enum TransportationMethods {
  WALKING = 'WALKING',
  DRIVING = 'DRIVING',
  BICYCLING = 'BICYCLING',
}

export default TransportationMethods;
